import { fromJS } from 'immutable';
import {
  RECEIVE_SERVICES,
  REQUEST_SERVICE,
  RECEIVE_SERVICE,
  ALL_SERVICES_FETCHED,
} from '../constants';


const initialState = fromJS({
  items: [],
  allFetched: false,
});

export default function servicesReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_SERVICE:
      return state.set('allFetched', false);

    case ALL_SERVICES_FETCHED:
      return state.set('allFetched', true);

    case RECEIVE_SERVICES:
      return state.set('items', fromJS(action.payload));

    case RECEIVE_SERVICE: {
      const index = state.get('items').findIndex(item => item.get('id') === action.payload.id);
      return state.setIn(['items', index === -1 ? state.get('items').size : index], fromJS(action.payload));
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reducer.js